import LazyLoad from "vanilla-lazyload";
import { isBrowser } from "@libs/utils/browser";
import type { ILazyLoadInstance } from "vanilla-lazyload";

let lazyLoadInstance: ILazyLoadInstance | null = null;
if (isBrowser() && !lazyLoadInstance) {
  lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
  });
}

// `Disable Cache` が有効な状態でChromeのNetworkタブを見ると重複して読んでるように
// 見えますが、2回目のリクエストはキャッシュされるので、実害はありません。
// SEE: https://github.com/verlok/vanilla-lazyload/issues/153#issuecomment-408164476
export const tryLazyLoad = (): void => {
  lazyLoadInstance && lazyLoadInstance.update();
};

export default tryLazyLoad;
